import styled from "@emotion/styled";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router";

import heroImg from "@/../../hypetrain/static/img/home-hero.png";
import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints, isXsQuery, Media } from "@/components/layout/Media";
import { Container, StyledLinkBtn } from "@/components/pieces/bootstrap";
import { FiveStars } from "@/components/pieces/marketing/FiveStars";
import { InPartnership } from "@/components/pieces/marketing/InPartnership";
import { BRAND_PURPLE, MIDTEXT_COLOR } from "@/css/constants";

export function MainHero() {
  const isXs = useMediaQuery(isXsQuery);

  const heroContent = (
    <Flex
      flexDirection="column"
      justifyContent={["center", "center", "flex-start"]}
      alignItems={["center", "center", "flex-start"]}
    >
      <InPartnership />
      <Box textAlign={["left", "center", "left"]}>
        <Headline>Grow faster with a coach</Headline>
        <Box fontSize={26}>
          Work with a world-class coach to grow as a leader, find career
          clarity, or accelerate your job search.
        </Box>
      </Box>
      <Box mt={40} width={isXs ? "100%" : 350}>
        <StyledLinkBtn
          to={`/match?type=find%20my%20agent%20button&source=${encodeURIComponent(
            "pro page",
          )}`}
          style={{ width: isXs ? "100%" : 350 }}
        >
          <Flex py={2} fontSize={22} justifyContent="center">
            Find My Coach
          </Flex>
        </StyledLinkBtn>
      </Box>
      <Box mt={3} maxWidth="100%" width={isXs ? "100%" : 350}>
        <Link to="/learn/gift" style={{ display: "block" }}>
          <GiftButton style={{ width: isXs ? "100%" : 350 }}>
            Give As Gift
          </GiftButton>
        </Link>
      </Box>
      <Flex width={["100%", "auto", "auto"]} mt={3} alignItems="center">
        <FiveStars />
        <Box color={MIDTEXT_COLOR}>4.9 Average Session Rating</Box>
      </Flex>
    </Flex>
  );

  return (
    <Box
      mt={55}
      py={[30, 40, 50, 80]}
      px={[3, 0]}
      style={{
        background: "linear-gradient(180deg, #E5F0FD 19.13%, #FBFBFF 103.73%)",
      }}
    >
      <Media lessThan="sm">{heroContent}</Media>
      <Media greaterThanOrEqual="sm">
        <Container className="!max-w-marketing-content">
          <Flex
            justifyContent={[
              "space-around",
              "space-around",
              "space-around",
              "space-between",
            ]}
            alignItems="center"
          >
            <Box width={[1, 1, 520]}>{heroContent}</Box>
            <Media greaterThanOrEqual="md">
              <Box ml={[40, 40, 40, 100]}>
                <img src={heroImg} width="100%" />
              </Box>
            </Media>
          </Flex>
        </Container>
      </Media>
    </Box>
  );
}

const Headline = styled("h1")`
  font-size: 70px;
  font-weight: 700;
  color: ${BRAND_PURPLE};
  line-height: 1.1;

  @media screen and (max-width: ${breakpoints.lg}px) {
    font-size: 60px;
  }
`;

const GiftButton = styled("button")`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  text-align: center;
  color: ${MIDTEXT_COLOR};
  box-shadow:
    0 1px transparent,
    0 1px 3px rgba(0, 0, 0, 0.09);
  white-space: nowrap;
  cursor: pointer;
  line-height: 1.4;
  user-select: none;
  position: relative;
  background: #fff;
  height: 70px;
  border: 2px solid rgba(255, 255, 255, 0.6);
  transition: all 200ms ease;
  font-size: 22px;
  font-weight: 600;
  max-width: 100%;
  padding: 12px 20px;
  border-radius: 8px;
  z-index: 1;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border: 2px solid #fff;
  }
`;
